import fetchApi from '../../Services/requests';
import { LandingUrl } from '../../Routes/landing.route';
import { LandingInfoDataType } from '../../Types/landing.type';

export const getLandingDataAction = async (
  set,
  body: { smartGuid: string }
): Promise<LandingInfoDataType> => {
  set({
    landingLoading: true,
    landingError: false,
    landingData: null
  });
  const response = await fetchApi(LandingUrl(), body);

  response?.ok
    ? set({
        landingLoading: false,
        landingError: false,
        landingData: response.data
      })
    : set({
        landingLoading: false,
        landingError: true,
        landingData: null
      });
  return response?.data;
};
